import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { Search, Grid, Label } from 'semantic-ui-react'


const SearchActividades = (props) => {
	const [ loading, setLoading ] = useState(false);
	const [ results, setResults ] = useState([]);
	const [ value, setValue ] = useState('');
	const { source } = props;

	const setResuts = (action) => {
		switch (action.type) {
			case 'CLEAN_QUERY':
				setLoading(false);
				setResults([]);
				setValue('');
				break;
			case 'START_SEARCH':
				setLoading(true);
				setValue(action.query);
				break;
			case 'FINISH_SEARCH':
				setLoading(false);
				setResults(action.results);
				break;
			case 'UPDATE_SELECTION':
				setValue(action.selection);
				break;
			default:
				throw new Error()
		}
	}

	const timeoutRef = React.useRef();
	const handleSearchChange = React.useCallback((e, data) => {
		clearTimeout(timeoutRef.current)
		setResuts({ type: 'START_SEARCH', query: data.value });

		timeoutRef.current = setTimeout(() => {
			if (data.value.length === 0) {
				setResuts({ type: 'CLEAN_QUERY' });
				return;
			}

			const re = new RegExp(_.escapeRegExp(data.value), 'i')
			const isMatch = (result) => re.test(result.Actividad);

			setResuts({
				type: 'FINISH_SEARCH',
				results: _.filter(source, isMatch),
			});

		}, 300);
	}, [source])

	useEffect(() => {
		return () => {
			clearTimeout(timeoutRef.current)
		}
	}, [])

	const updateSelection = (data) => {
		setResuts({ type: 'UPDATE_SELECTION', selection: data.result.Actividad });
		props.onClick(data.result);
	}

	const resultRenderer = ({ CodigoActividad, Actividad }) => {
		return (
			<div className="ui column fluid grid">
				<div className="ui sixteen column fluid">
					<Label content={`${CodigoActividad} - ${Actividad}`} />
				</div>
			</div>
		)
	}

	return (
		<div className="search-container">
			<Grid>
				<Grid.Column width={16}>
					<Search
						loading={loading}
						onResultSelect={(e, data) =>
							updateSelection(data)
						}
						onSearchChange={handleSearchChange}
						resultRenderer={resultRenderer}
						results={results}
						value={value}
					/>
				</Grid.Column>
			</Grid>
		</div>
	)
}

export default SearchActividades;